import { ChangeEvent, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Modal from '@/shared/components/Modal/Modal'
import TextField from '@/shared/components/TextField/TextField'
import Button from '@/shared/components/Button/Button'
import styles from './RoomManageModal.module.scss'

interface RoomManageModalProps {
  isOpen: boolean
  mode: 'create' | 'rename'
  initialName?: string
  onClose: () => void
  onConfirm: (name: string) => void
}

function RoomManageModal(props: RoomManageModalProps) {
  const { isOpen, mode, initialName = '', onClose, onConfirm } = props
  const { t } = useTranslation()
  const [name, setName] = useState(initialName)

  useEffect(() => {
    if (isOpen) setName(initialName)
  }, [isOpen, initialName])

  const title =
    mode === 'create' ? t('FLOOR_PLAN.ROOM.ADD') : t('FLOOR_PLAN.ROOM.RENAME')

  const handleConfirm = () => {
    const trimmed = name.trim()
    if (!trimmed) return
    onConfirm(trimmed)
    onClose()
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={title} size="small">
      <div className={styles.body}>
        <TextField
          label={t('FLOOR_PLAN.ROOM.NAME_LABEL')}
          value={name}
          onChange={(e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
            setName(e.target.value)
          }
          focused
        />
        <div className={styles.actions}>
          <Button
            label={t('COMMON.CANCEL')}
            variant="outlined"
            color="primary"
            onClick={onClose}
          />
          <Button
            label={t('COMMON.SAVE')}
            variant="contained"
            color="primary"
            disabled={!name.trim()}
            onClick={handleConfirm}
          />
        </div>
      </div>
    </Modal>
  )
}

export default RoomManageModal
